import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import SurveyService from '../../../../Services/surveyService';

// Trivial placeholder: the wizard only instantiates windowDescription.itemType when no
// editedItem prop is passed. SurveyAdmin always passes a pre-fetched editedItem (crudType=Create,
// built in SurveyAdmin.clickOnAddSurvey), so this is never invoked, but it keeps the
// windowDescription contract satisfied.
class AddSurveyEditItem {}

export default class AddSurveyWindowDescription {
  static titleForCreate = 'Apply Survey';
  static itemType = AddSurveyEditItem;
  static finishButtonLabel = 'Submit';
  static messageOnSuccess = 'Surveys have been applied.';

  // Keeps AvailableSurveys[].SelectedInList in sync with the MultiChoice selection and points
  // SelectedRows at the selected row OBJECTS (same references as AvailableSurveys) so the per-row
  // edits (IsUninvoiceable/SurveyType) land on the exact objects serviceFunction posts back.
  // Synchronous only - onFieldChange's return value is written straight into editedItem and must
  // never be a Promise (see GeneralEditWizzardPageFigma.updateRelatedData).
  static syncSelectedRows(item) {
    const selectedIds = item.SelectedSurveyIds ?? [];
    item.AvailableSurveys.forEach((survey) => {
      survey.SelectedInList = selectedIds.some((id) => String(id) === String(survey.SassieId));
    });
    item.SelectedRows = item.AvailableSurveys.filter((survey) => survey.SelectedInList);
  }

  // Mirrors the old AddSurveyPanel's handleOnSubmit: posts the AvailableSurveys rows that are
  // selected (with any per-row edits, since SelectedRows references the same objects). MUST
  // return the promise (wizard contract).
  static serviceFunction = (edited) =>
    SurveyService.EditSurvey(edited.AvailableSurveys.filter((survey) => survey.SelectedInList));

  static pagesInGeneralEditWizzard = [
    {
      fields: [
        {
          fieldName: 'SelectedSurveyIds',
          label: 'Surveys',
          className: 'col-12',
          type: InputTypesEnum.MultiChoice,
          selectvalues: (item) => item.AvailableSurveys.map((survey) => ({ label: survey.DisplayLabel, value: survey.SassieId })),
          validityChecker: ValidityHelper.forRequiredMultiSelectField,
          onFieldChange: (item) => AddSurveyWindowDescription.syncSelectedRows(item),
        },
        {
          fieldName: 'SelectedRows',
          valueField: 'IsUninvoiceable',
          labelField: 'DisplayLabel',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: [
            { label: 'No', value: false, disabled: false },
            { label: 'Yes', value: true, disabled: false },
          ],
          // The old AddNewSurvyElement rows had no validators on these two fields.
          validityChecker: (e, item, index) => '',
        },
        {
          fieldName: 'SelectedRows',
          valueField: 'SurveyType',
          labelField: 'DisplayLabel',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: [
            { label: '', value: '', disabled: false },
            { label: 'Calls Emails', value: 'CallsEmails', disabled: false },
          ],
          validityChecker: (e, item, index) => '',
        },
      ],
    },
  ];
}
